import React from 'react';

import { Register } from 'presentation/pages';

export const MakeRegisterFactory: React.FC = () => {
  return <Register />;
};
